import api from "./api";

export const getAllSnmps = async (schemaName = null, filterParams = {}) => {
  try {
    const response = await api.get("/snmps/", { 
      params: { client: schemaName, ...filterParams } 
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching hosts:", error);
    throw error;
  }
};

export const createSNMP = async (hostData, schemaName = null) => {
  try {
    const response = await api.post("/snmps/", hostData, { 
      params: { client: schemaName } 
    });
    return response.data;
  } catch (error) {
    console.error("Error creating snmp:", error);
    throw error;
  }
};


export const updateSNMP = async (id,hostData, schemaName = null) => {
  try {
    const response = await api.patch(`/snmps/${id}/`, hostData, { 
      params: { client: schemaName } 
    });
    return response.data;
  } catch (error) {
    console.error("Error updating snmp:", error);
    throw error;
  }
}; 


export const deleteSNMP = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/snmps/${id}/`, {
      params: { client: schemaName } 
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting snmp:", error);
    throw error;
  }
};  